/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IArborb2bContactFormViewProps } from './arborb2b-contact-form';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import EndorsementForm from './form';

export default (props: IArborb2bContactFormViewProps) => {
    return (
        <>
            <EndorsementForm />
        </>
    );
};
